export const TOKEN_STORAGE_KEY = 'sessionToken'
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken'
export const USER_STORAGE_KEY = 'user'
